export const GLOBAL_STATE = 'ContractAgreement'

export const CONTRACT_AGREEMENT = 'CONTRACT_AGREEMENT' as const
export const CONTRACT_AGREEMENT_ALL = 'CONTRACT_AGREEMENT_ALL' as const
export const CONTRACT_AGREEMENT_CURRENT = 'CONTRACT_AGREEMENT_CURRENT' as const
export const CONTRACT_AGREEMENT_ACCEPT = 'CONTRACT_AGREEMENT_ACCEPT' as const
export const CONTRACT_AGREEMENT_OPEN = 'CONTRACT_AGREEMENT_OPEN' as const
export const CONTRACT_DOWNLOAD = 'CONTRACT_DOWNLOAD' as const
